<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-6-chaos-2035">
<h1>Chapter 6<br/> Chaos (2035)</h1>
<p>Dax, the Maine Coon cat, is lying in the garden, enjoying the morning sun, when he vanishes. Penelope, the Adélie penguin, is enjoying a day of fun and games with her friends, in her home in Antarctica, when she suddenly disappears into thin air. Florence, the Jersey cow, is enjoying a morning of grazing on lush grass, on her farm, in Queensland, Australia, when she suddenly disappears into thin air. One by one, they re-materialise on the spaceship with Bjorn and Zorn. Bjorn and Zorn have created a special chamber for Penelope. We see her behind glass in a chamber that recreates Antarctic conditions. Before the animals realise what is happening, Bjorn and Zorn create golden balls of light which enter the heads of Dax, Penelope, and Florence.</p>
<p>“What a clever trick. I can now tell the world who the boss is,” says Dax.</p>
<p>“Boss?” asks Bjorn.</p>
<p>“Cats are ancient beings, and should receive respect,” claims Dax.</p>
<p>“Zorn might agree with you, but I don’t.” Bjorn laughs.</p>
<p>Zorn imitates a cat scratch. “Cats rule!”</p>
<p>Dax laughs. “I think I’m going to like you.”</p>
<p>“We cats need to stick together,” says Zorn.</p>
<p>“You’re hilarious. Just between us cats, what’s the story? What’s the um? Quest? Who are you guys?” asks Dax.</p>
<p>Zorn explains, “We are aliens from the planet Aeon. When our race discovered the Earth, we began our normal action to sit back and observe. We are time travellers and can see what has come before, and what may happen in the future. We normally have a non-interference policy, but we know they will destroy the Earth in less than twenty years. The bosses on our home world of Aeon have instructed us to investigate and try to prevent the catastrophe.”</p>
<p>“I don’t understand what you think we can do to help,” says Dax. Bjorn joins the conversation, “For a start, you can help us with understanding humans. The rest we’ll make up as we go along.”</p>
<p>Dax says, “Trust me, trying to understand humans will make your head ache.”</p>
<br/>
<p style="text-align: center;">***</p><br/>
<p>Dax is sitting on the computer console, looking down at Ptoni as he stirs.</p>
<p>“Hard night?” enquires Dax.</p>
<p>“That ain’t half of it,” replies Ptoni. “Hey, it’s a talking ball of fur.”</p>
<p>Ptoni passes out again.</p>
<p>“I’m thinking Ptoni’s unevolved brain is the problem. He just can’t process what is happening,” suggests Bjorn.</p>
<p>“What do you suggest we do?” asks Zorn.</p>
<p>Suddenly, in the background, someone is heard knocking.</p>
<p>“Surely, you two can make adjustments to the brain’s integration parameters… that can upgrade his software… so to speak,” suggests Dax.</p>
<p>“Like how?” asks Bjorn.</p>
<p>“Don’t ask me, I’m just a cat,” says Dax.</p>
<p>“On it,” says Zorn.</p>
<p>The knocking continues.</p>
<p>Dax points to Penelope through the glass. “Are you going to answer her?”</p>
<p>“THAT’S what that noise is,” says Bjorn with relief in his voice.</p>
<p>Bjorn walks over to a panel beside the glass. He presses a button, turning on the audio.</p>
<p>Penelope, now distraught, squeals loudly, “What’s going on? What are you saying? Why has the dinosaur passed out? Why is it so hot in here?”</p>
<p>Dax, annoyed by her squealing, asks, “Why did you give her the ability to speak?”</p>
<p>He jumps across the room, hitting the button on the wall, turning off the speakers.</p>
<p>“Not nice, cat,” says Bjorn, turning the speakers back on.</p>
<p>“Yeah, cat, not nice,” squeals Penelope.</p>
<p>Dax jumps across the room and turns the audio off again.</p>
<p>“I will not spend this whole quest listening to her whine,” says Dax, even more annoyed.</p>
<p>Suddenly, the ship’s computer says, “Download complete.”</p>
<p>“Zorn, the penguin’s complaining about the temperature,” says Bjorn.</p>
<p>“On it,” says Zorn.</p>
<p>“On it,” says Dax in a sassy imitation of Zorn. “This is going to be a long quest…”</p><br/>
<p style="text-align: center;">***</p><br/>
<p>Suddenly, a very excited Ptoni sits up and blurts out, “What’s going on? What are you saying? Why is the penguin behind glass? Why is it so cold in here?”</p>
<p>“That cat is a grumpy little munchkin. Can someone milk me? My teats hurt,” says Florence, finally uttering her first words.</p>
<p>“I thought you’d never ask,” says Dax.</p>
<p>Dax sits up under Florence and squeezes some milk into his mouth from her udders.</p>
<p>Florence sighs, “A little better.”</p>
<p>The excited Ptoni continues, “What’s going on? What are you saying? Why is the penguin behind glass? Why is it so cold in here?”</p>
<p>“Zorn, the Pteranodons’ stuck in a loop,” says Bjorn.</p>
<p>“On it,” says Zorn.</p>
<p>“Give me strength,” says Dax, now even more annoyed.</p>
<p>“And fix the cat,” adds Bjorn.</p>
<p>Dax, adopting the ‘ninja’ position, says, “Don’t even try it.”</p>
<p>Zorn points a scanner at Dax. “On it.”</p>
<p>Dax passes out.</p>
<p>“It’s still too hot in here,” says Penelope.</p>
<p>“My teats still hurt,” says Florence.</p>
<p>“What’s going on? What are you saying? Why is the penguin behind glass? Why is it so cold in here?” from Ptoni.</p>
<p>“I can’t stand any more of this,” says Bjorn, picking up a scanner.</p>
<p>He points the scanner at them all, and they all pass out.</p>
<p>Bjorn, as if thinking out loud, says, “Remind me why we want to save that ball of water again.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch010.vue?1ae35d02